<template>
  <el-drawer :visible.sync="outDrawer" size="100%" id="el-drawer__title" :show-close="false">
    <div class="flex space-between aic pr20 bb">
      <header-time></header-time>
      <el-row>
        <el-button plain @click="hide"><span class="pl20 pr20">关闭</span></el-button>
      </el-row>
    </div>
    <div class="prescription">
      <recipe-head-btn :orderType="orderType"
                       :sub="sub"
                       :end="subStatus"
                       :source="source"
                       @handler="(name,type)=>{doRecipeAction(name, type)}">
      </recipe-head-btn>
      <div class="mt20 flex jcb">
        <div class="width100 bg_fff">
          <el-tabs v-model="activeTab" type="card" closable
                   class="pl20 pr20"
                   @tab-remove="removeTab" @tab-click="tabChange">
            <el-tab-pane
                v-for="(item) in tabsList"
                :key="item.name"
                :label="item.title"
                :name="item.name">
            </el-tab-pane>
          </el-tabs>
          <recipe-info
              :info="currentRecipe"
              :patient="patientInfo"
              :type="orderType"
              :subs="subStatus"
              :su="sub"
              :drugAdmissionList="drugAdmissionList"
              :drugFrequencyList="drugFrequencyList"
              :tcmAdmissions="tcmAdmission"
              @handler="(name,type)=>{doRecipeAction(name, type)}"
              @medicineAdd="medicineAdd"
              @handleSelect="handleSelect"
              @medicineDelete="medicineDelete"
              @changeTcmAdmission="changeTcmAdmission"
              @changeDiagnosis="changeDiagnosis"
              @updateCurrentRecipe="onUpdateCurrentRecipe"
          ></recipe-info>
        </div>
      </div>
      <history-rp-dialog ref="hisDialog"
                         :hisList="historyRpList"
                         :page="page2"
                         :orderType="orderType"
                         :patientInfo="patientInfo"
                         :drugList="currentRecipe.drugList"
                         @changePage="changePage"
                         @replaceCurrent="replaceCurrent">
      </history-rp-dialog>
      <add-used-dialog ref="usedAdd"
                       :orderType="orderType"
                       :drugList="currentRecipe.drugList">
      </add-used-dialog>
      <el-drawer :visible.sync="inDrawer" :modal-append-to-body="true" :append-to-body='true'>
        <p class="pl15 overstriking color_main">申请处方详情</p>
        <div :style="{height:clientHeight+'px'}" class="overflow-y-auto">
          <patient-detail :info="orderInfo"
                          :inEPrescription=true
                          :recipe="recipeInfo"
          ></patient-detail>
        </div>
      </el-drawer>
      <recipe-preview ref="preview"
                      source="EPrescription"
                      :info="Object.assign({}, currentRecipe, patientInfo, docInfo, {orderType: orderType})"
                      :drugs="currentRecipe.drugList"
                      @handler="(name,type)=>{doRecipeAction(name, type)}">
      </recipe-preview>
    </div>
  </el-drawer>
</template>

<script>
import {tokenCache} from "../../lib/cache/Token"
import {sexFilter, getSexFromIdCardFilter, getAgeFromIdCardFilter} from "../../lib/filters";
import {isEmpty} from "../../lib/utils";
import {recipeService} from "../../lib/service/recipe";
import HistoryRpDialog from "../../components/prescription/history-rp-dialog"
import PatientDetail from "../../components/prescription/patient_detail";
import AddUsedDialog from "../../components/prescription/add-used-dialog";
import RecipeInfo from "../../components/prescription/recipe-info";
import RecipeHeadBtn from "../../components/prescription/recipe-head-btn";
import HeaderTime from "../../components/common/header-time";
import RecipePreview from "../../components/prescription/recipe-preview";

const PAGE = {
  pageNum: 1,
  pageSize: 5,
  pages: 1,
  total: 0
};
export default {
  name: "EPrescription",
  props: {
    info: Object, //处方参数
    orderDetail: Object, //订单信息
    source: String,
  },
  data() {
    return {
      outDrawer: false,
      inDrawer: false,
      recipeInfo: {}, //处方所需参数
      orderInfo: {}, //原订单信息
      activeTab: '',
      tabIndex: 1,
      tabsList: [],
      allPrescritionList: {
        1: {
          drugList: [{}], //处方药品列表
          admission: '',//用法
          diagnosis: "", //诊断
          allergyHistory: "", //过敏史
          dosageForm: '饮片', //药品剂型（饮片、颗粒）
          tcmDosage: 1, //中药剂数
          tcmAdmission: '', //中药用法、频次
          exclusionFlag: false, //不存在互斥
          exclusionRemark: '',//互斥药品信息
          subStatus: false //未提交
        }
      },
      drugAdmissionList: [],//用法
      drugFrequencyList: [],//频次
      diagnosis: "",
      diagnosisTemp: "",
      sub: false, //  从我的处方页-重新开方
      page2: PAGE,
      historyRpList: [],
      subStatus: false, //是否结束了续方，
      currentRecipe: {}, //当前处方
      recipePdfUrl: '', //医生签名图片
      orderType: '',
      patientInfo: {},
    };
  },
  filters: {
    sexFilter,
    getSexFromIdCardFilter,
    getAgeFromIdCardFilter
  },
  computed: {
    clientHeight() {
      return (document.documentElement.clientHeight - 1 || document.body.clientHeight - 1)
    },
    showTabIndex() {
      return this.activeTab.slice(3)
    },
    tcmAdmission: {
      get: function () {
        if (this.currentRecipe) return this.currentRecipe.tcmAdmission
      },
      set: function (value) {
        this.allPrescritionList[this.showTabIndex].tcmAdmission = value
      }
    },
    //处方来源
    bizType() {
      return this.recipeInfo.bizType
    }
  },
  components: {RecipePreview, HeaderTime, RecipeHeadBtn, RecipeInfo, AddUsedDialog, PatientDetail, HistoryRpDialog},
  watch: {
    info: {
      handler(newV) {
        this.recipeInfo = newV
        this.init()
        if (this.recipeInfo.rpId) {
          this.getRpInfo()
        }
      }
    },

    orderDetail: {
      handler(newV) {
        this.orderInfo = newV
        //患者信息
        let form = {}
        let info = newV
        form.patId = info.patId || info.hzid
        form.compatId = info.compatId || info.jzrid
        form.compatName = info.compatName ? info.compatName : info.commpatName ? info.commpatName : info.consulterName
        Log('gender', info.compatGender || info.commpatGender || info.consulterGender);
        form.sex = sexFilter(info.compatGender) || sexFilter(info.commpatGender) || sexFilter(info.consulterGender)
        form.compatGender = info.compatGender || info.commpatGender || info.consulterGender || (form.sex === '男' ? 'M' : 'F')
        form.compatMobile = info.compatMobile || info.commpatMobile || info.sjh || info.consulterMobile
        form.compatAge = info.compatAge || info.commpatAge
        form.compatAddress = info.compatAreaName || info.compatAddress || info.areaName
        form.orderNo = info.orderNo
        this.patientInfo = form
      },
      immediate: true
    },
    showTabIndex: {
      handler(newV) {
        this.currentRecipe = this.allPrescritionList[newV]
      }
    },
    allPrescritionList: {
      handler(newV) {
        // console.log('【处方列表发生了变化】')
        this.currentRecipe = newV[this.tabIndex]
      },
      deep: true
    }
  },
  methods: {
    onUpdateCurrentRecipe(data) {
      for (let dataKey in data) {
        this.$set(this.currentRecipe, dataKey, data[dataKey]);
      }
    },


    init() {
      this.orderType = this.recipeInfo.type
      this.activeTab = this.recipeInfo.type === 'WESTERN_RECIPE' ? '西药方1' : '中药方1'
      this.tabsList = this.recipeInfo.type === 'WESTERN_RECIPE' ?
          [{title: '西药方1', name: '西药方1',}] : [{title: '中药方1', name: '中药方1',}]
    },
    clean() {
      this.tabIndex = 1
      this.currentRecipe = {drugList: [{}]}
      this.diagnosis = ""
      this.diagnosisTemp = ""
      this.allPrescritionList = {
        1: {
          drugList: [{}], //处方药品列表
          admission: '',//用法
          diagnosis: "", //诊断
          allergyHistory: "", //过敏史
          dosageForm: '饮片', //药品剂型（饮片、颗粒）
          tcmDosage: 1, //中药剂数
          tcmAdmission: '', //中药用法、频次
          exclusionFlag: false, //不存在互斥
          exclusionRemark: '',//互斥药品信息
          subStatus: false //未提交
        }
      }
      this.page2 = PAGE
      this.subStatus = false

    },
    getSexFromIdCardFilter,
    getAgeFromIdCardFilter,
    show() {
      this.outDrawer = true
      this.init()
      this.getMedicineParams()
    },
    hide() {
      let hasDrug = this.currentRecipe.drugList.some(item => {
        return item.drugName
      })

      let empty = true
      let obj = this.allPrescritionList
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key]);
        let info = obj[key]
        if (info.diagnosis || info.tcmAdmission) {
          empty = false
        }
      });
      if ((hasDrug || !empty) && !this.currentRecipe.subStatus) {
        this.$confirm('您开具的处方还未提交，确定关闭开后处方数据将不会保存？', '关闭提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '暂不关闭',
          type: 'warning'
        }).then(() => {
          this.clean()
          this.outDrawer = false
        }).catch(() => {
        })
      } else {
        this.clean()
        this.outDrawer = false
      }
    },
    doRecipeAction(name, type) {
      const map = this.getRecipeActionMap();
      const action = [...map].find(r => r[0] === name);
      if (isEmpty(action)) this.$message.error(`未定义 ${name} 操作!`);
      else {
        action[1](name, type);
      }
    },
    getRecipeActionMap() {
      return new Map([
        ['添加中药方', () => {
          this.addTab('中药')
        }],
        ['添加西药方', () => {
          this.addTab('西药')
        }],
        ['导入处方', async () => {
          let res = await this.getPatHisRecipe()
          if (res) {
            this.$refs.hisDialog.show()
          }
        }],
        ['添加至常用方', async () => {
          let check = this.currentRecipe.drugList.filter((item) => {
            return item.drugName
          })
          if (check.length === 0) {
            this.$alert('您当前的处方页内没有数据，请先维护药品数据然后再添加至常用方', '提示', {
              confirmButtonText: '确定',
            });
          } else {
            this.$refs.usedAdd.show()
          }
        }],
        ['查看订单详情', () => {
          this.inDrawer = true
        }],
        ['提交处方', async () => {
          let res = await this.checkError()
          if (res) {
            this.$refs.preview.show()
          }
        }],
        ['确认开方', () => {
          this.submitPrescription('')
        }],
        ['去签名', () => {
          this.submitPrescription('needSign')
        }],
        ['结束续方', () => {
          this.addTab('西药')
        }],
        ['返回上一页', () => {
          this.$router.back()
        }],
        ['打印', () => {
          window.open(this.recipePdfUrl);
        }],
      ])
    },
    changeDiagnosis(diagnosis) {
      this.allPrescritionList[this.showTabIndex].diagnosis = diagnosis
    },
    changeTcmAdmission(tcmAdmission) {
      this.allPrescritionList[this.showTabIndex].tcmAdmission = tcmAdmission
    },
    async getRpInfo() {
      this.sub = this.recipeInfo.handle === 'sub'
      const obj = await recipeService.info(this.recipeInfo.rpId);
      this.diagnosis = obj.diagnosis
      this.allPrescritionList[this.showTabIndex].diagnosis = obj.diagnosis
      for (let i of obj.drugList) {
        i.frequencyObj = i.frequencyCode + '/' + i.frequencyName
        i.price = i.drugUnitPrice
      }
      obj.drugList && obj.drugList.forEach(item => {
        item.id = item.drugId
      })
      this.allPrescritionList[this.showTabIndex].drugList = obj.drugList
      this.allPrescritionList[this.showTabIndex].tcmAdmission = obj.tcmAdmission
      this.allPrescritionList[this.showTabIndex].tcmDosage = obj.tcmDosage
      this.allPrescritionList[this.showTabIndex].admission = obj.admission
      this.allPrescritionList[this.showTabIndex].orderNo = obj.orderNo
    },
    //选择药品
    handleSelect(item, index) {
      let drugList = this.allPrescritionList[this.showTabIndex].drugList
      let idList = []
      drugList.forEach((item) => {
        idList.push(item.id)
      })
      if (drugList.length > 0) {
        if (!drugList.includes(item) && idList.indexOf(item.id) < 0) {
          this.allPrescritionList[this.showTabIndex].drugList[index] = item
        } else {
          //判断重复药品是否为本行药品，本行药品直接覆盖
          let isSameLine = drugList[index].id === item.id
          if (isSameLine) {
            this.allPrescritionList[this.showTabIndex].drugList[index] = item
          } else {
            let list = item
            for (let key in list) {
              delete list[key]
            }
            this.allPrescritionList[this.showTabIndex].drugList[index] = list
            return this.$message.error('请勿重复添加药品')
          }

        }
      } else {
        this.allPrescritionList[this.showTabIndex].drugList[index] = item
      }
    },
    //获取药品字典
    async getMedicineParams() {
      let obj = await recipeService.drugDict()
      if (Object.values(obj).length > 0) {
        this.drugAdmissionList = this.orderType === 'CHINESE_RECIPE' ?
            obj.drugAdmissionList : obj.westernDrugAdmissionList
        for (let i of obj.drugFrequencyList) {
          i.frequencyObj = i.dictKey + '/' + i.dictValue
        }
        this.drugFrequencyList = obj.drugFrequencyList
      }
    },
    /**
     * 新增tab标签
     * @param tabName
     */
    addTab(tabName) {
      const index = ++this.tabIndex
      let newTabName = index + '';
      this.tabsList.push({
        title: tabName + "方" + newTabName,
        name: tabName + "方" + newTabName,
      });
      this.activeTab = tabName + "方" + newTabName;
      this.allPrescritionList[index] = {
        drugList: [{}], //处方药品列表
        diagnosis: "", //诊断
        admission: '',//用法
        dosageForm: '饮片', //药品剂型（饮片、颗粒）
        tcmDosage: 1, //中药剂数
        tcmAdmission: '', //中药用法、频次
        subStatus: false //未提交
      }
      this.diagnosisTemp = '';
      this.subStatus = this.allPrescritionList[index].subStatus = false
    },
    tabChange() {
      this.diagnosisTemp = '';
      this.subStatus = this.allPrescritionList[this.showTabIndex].subStatus
    },
    //删除处方单
    removeTab(targetName) {
      if (this.tabsList.length <= 1) {
        this.$message({
          type: 'warning',
          message: '请至少保留一个处方单！'
        })
        return
      }
      this.$confirm(`是否确定删除${targetName},删除后不可恢复，仍要继续该操作？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let tabs = this.tabsList;
        let activeName = this.activeTab;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              nextTab && (activeName = nextTab.name)
            }
          });
        }
        this.activeTab = activeName;
        this.tabsList = tabs.filter(tab => tab.name !== targetName);
        let index = targetName.slice(3, 4)
        delete this.allPrescritionList[index]
        // this.selectedMedicineListTemp = this.allPrescritionList[this.showTabIndex].selectedM
        this.diagnosisTemp = ''
        this.subStatus = this.allPrescritionList[this.showTabIndex].subStatus
        this.tabIndex = this.showTabIndex
        // this.$message.success(`删除成功!`);
      }).catch(() => {
        /* this.$message({
           type: 'info',
           message: '已取消删除'
         });*/
      })
    },
    medicineDelete(i) {
      this.allPrescritionList[this.showTabIndex].drugList.splice(i, 1)
    },
    medicineAdd() {
      this.allPrescritionList[this.showTabIndex].drugList.push({})
    },
    //检查处方
    async checkError() {
      if (this.allPrescritionList[this.showTabIndex].subStatus) {
        this.$message.error('该处方单已提交,不可重新提交！')
        return false
      }
      let empty = this.allPrescritionList[this.showTabIndex].drugList.filter((item) => {
        return !item.drugName
      })
      if (empty.length > 0) {
        return this.$confirm('您所提交的处方中有一处空白，请完善处方或删除后再次提交。', '请注意', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        }).then(() => {
          return false
        }).catch(() => {
          return false
        })
      }
      let error = false
      this.allPrescritionList[this.showTabIndex].drugList.forEach((d) => {
        if (isEmpty(d.dosage)) {
          this.$message.error('请选择单次剂量')
          error = true
        } else if (this.orderType === 'WESTERN_RECIPE' && isEmpty(d.frequencyObj)) {
          this.$message.error('请选择频次')
          error = true
        } else {
          !d.drugId && (d.drugId = d.id)
          if (this.orderType === 'WESTERN_RECIPE') {
            d.frequencyCode = d.frequencyObj.split('/')[0]
            d.frequencyName = d.frequencyObj.split('/')[1]
          }
        }
      })
      if (error) return false
      if (!this.allPrescritionList[this.showTabIndex].diagnosis) {
        this.$message.error('处方诊断不能为空')
        return false
      }

      let check = await this.checkDrug()
      if (!check) return false
      return true
    },
    //检查中药是否存在互斥
    async checkDrug() {
      let options = {
        drugList: this.currentRecipe.drugList,
        orderType: this.orderType,
      }
      let t = {
        dosageForm: this.currentRecipe.dosageForm,
        tcmDosage: this.currentRecipe.tcmDosage,
        tcmAdmission: this.tcmAdmission,
      }
      if (this.orderType === 'CHINESE_RECIPE') options = {
        drugList: this.currentRecipe.drugList,
        orderType: this.orderType,
        ...t
      }

      const {code, obj} = await this.$http('smarthos.recipe.drug.exclusion.validate', options)
      if (code === '0' && obj.exclusionFlag) {
        return this.$confirm(`您所开具的处方内有互斥药品存在，是否仍要提交？</br><span style="color: red">${obj.exclusionRemark}</span>`, '', {
          cancelButtonText: '再修改下',
          confirmButtonText: '确定提交',
          dangerouslyUseHTMLString: true,
          type: 'warning',
        }).then(() => {
          return true
        }).catch(() => {
          this.allPrescritionList[this.showTabIndex].exclusionFlag = obj.exclusionFlag
          this.allPrescritionList[this.showTabIndex].exclusionRemark = obj.exclusionRemark
          return false
        })
      } else if (code === '0' && !obj.exclusionFlag) {
        return true
      }
    },
    //提交处方
    async submitPrescription(value) {
      let bizId = this.recipeInfo.ddId || this.recipeInfo.bizId
      let orderId = null
      if (this.recipeInfo.handle && this.recipeInfo.handle === 'sub') {
        orderId = this.recipeInfo.rpId
      }
      let dia = this.currentRecipe.diagnosis
      let diagnosis = dia.charAt(dia.length - 1) === ',' ? dia.substring(0, dia.length - 1) : dia;//去除最后一个逗号
      const {code, obj} = await this.$http('smarthos.recipe.order.add', {
        ...this.patientInfo,
        ...this.currentRecipe,
        diagnosis: diagnosis,
        tcmDosage: Number(this.currentRecipe.tcmDosage),
        compatAge: this.patientInfo.compatAge,
        orderType: this.orderType,
        bizType: this.recipeInfo.bizType === 'online' ? 'ONLINE_OUTPATIENT' : this.recipeInfo.bizType,
        bizId: bizId,//原先业务订单id
        orderId: orderId,//原订单id(重新开方时必传)
        token: tokenCache.get()
      })
      if (code === '0') {
        /*  this.$confirm('您的处方已成功提交审核，是否打印处方？', '处方提交成功', {
            cancelButtonText: '取消',
            confirmButtonText: '打印',
            type: 'success',
          }).then(() => {
            window.open(obj.recipePdfUrl);
          }).catch(() => {
          })*/
        if (value === 'needSign') {
          this.$message.success('处方提交成功！');
        } else {
          this.$confirm(`您的处方已开具，请前往医护端APP进行签名`, '处方提交成功', {
            showCancelButton: false,
            confirmButtonText: '确定',
            type: 'success',
          }).catch(() => {
          })
        }
        this.subStatus = this.allPrescritionList[this.showTabIndex].subStatus = true
        this.allPrescritionList[this.showTabIndex].orderNo = obj.orderNo
        this.recipePdfUrl = obj.recipePdfUrl
      }
    },
    //获取患者历史处方列表
    async getPatHisRecipe() {
      const {code, list, page} = await this.$http('smarthos.recipe.order.pat.history.list', {
        patId: this.patientInfo.patId,
        compatId: this.patientInfo.ddxx ? this.patientInfo.ddxx.obj.jzrid : this.patientInfo.compatId,
        orderType: this.orderType,
        ...this.page2
      })
      if (code === '0') {
        this.historyRpList = list
        this.page2 = page
        return true
      } else {
        return false
      }
    },
    replaceCurrent(drugs) {
      this.allPrescritionList[this.showTabIndex].drugList = drugs
    },
    changePage(pageNum) {
      this.page2.pageNum = pageNum;
      this.getPatHisRecipe()
    },
  }
};
</script>

<style lang="scss">
#el-drawer__title {
  padding: 0 !important;
  margin: 0 !important;
}

.prescription {
  .el-form {
    padding-top: 22px;
    border-top: 1px solid #f5f5f5;
  }

  .el-table {
    margin-top: 15px;
  }

  .pagination-wrapper {
    padding: 20px 0;
  }

  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .pat_detail {
    height: 100%;
    overflow-y: auto;
  }
}

.record-item {
  padding: 15px 15px;

  .record-item-title {
    span {
      width: 4px;
      height: 14px;
      background-color: #3692F9;
      margin-right: 10px;
    }
  }

  .record-item-content {
    padding: 15px 15px;
    font-size: 14px;
    color: #999999;
  }
}

.el-table__header-wrapper {
  .cell {
    label.el-checkbox {
      display: none !important;
    }
  }
}

.medicine-table {
  height: 65%;
  overflow-y: auto;
  margin-top: 8px;

  .el-table__header-wrapper {
    .cell {
      font-size: 14px;
      font-weight: normal;
      color: #000;
    }
  }
}

.foot_chinese {
  align-items: center;
}

.tcmDosageInput {
  font-size: 14px;
  text-align: center;
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  outline: none;
}

</style>
